import React, { useContext } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { Container } from "semantic-ui-react";
import AdminHome from "./pages/admin/AdminHome";
import UserAdminPage from "./pages/admin/UserAdminPage";
import StudentAdminPage from "./pages/admin/StudentAdminPage";
import SubscriptionAdminPage from "./pages/admin/SubscriptionAdminPage";
import NewSubscriptionPage from "./pages/admin/NewSubscriptionPage";
import AssistantPage from "./pages/AssistantPage";
import ParentPage from "./pages/ParentPage";
import ClassPage from "./pages/ClassPage";
import StudentPage from "./pages/StudentPage";
import NewStudentPage from "./pages/NewStudentPage";
import StudentEditPage from "./pages/StudentEditPage";
import StudentQuestionsPage from "./pages/StudentQuestionsPage";
import ReportEditPage from "./pages/ReportEditPage";
import NewReportPage from "./pages/NewReportPage";
import ReportViewPage from "./pages/ReportViewPage";
import ReportsViewPage from "./pages/ReportsViewPage";
import PricingPage from "./pages/PricingPage";
import PostUpgradePage from "./pages/PostUpgradePage";
import SettingsPage from "./pages/SettingsPage";
import FieldSettingsPage from "./pages/FieldSettingsPage";
import Home from "./pages/Home";
import ErrorBoundary from "./components/ErrorBoundary";
import UserContext from "contexts/UserContext";
import AccessModalWrapper from "components/AccessModalWrapper";
import AppHeader from "components/AppHeader";

function RequireAuth({ children, test, redirectTo = "/" }) {
  const user = useContext(UserContext);
  return test(user) ? children : <Redirect to={redirectTo} />;
}

const App = (props) => {
  return (
    <Router>
      <Container>
        <AppHeader />
        <div className="app-content">
          <ErrorBoundary>
            <Switch>
              <Route exact path="/">
                <Home />
              </Route>
              <Route exact path="/admin">
                <RequireAuth test={(user) => user.isAdministrator}>
                  <AdminHome />
                </RequireAuth>
              </Route>
              <Route exact path="/admin/users/:id">
                <RequireAuth test={(user) => user.isAdministrator}>
                  <UserAdminPage />
                </RequireAuth>
              </Route>
              <Route exact path="/admin/subscriptions/new">
                <RequireAuth test={(user) => user.isAdministrator}>
                  <NewSubscriptionPage />
                </RequireAuth>
              </Route>
              <Route exact path="/admin/subscriptions/:id">
                <RequireAuth test={(user) => user.isAdministrator}>
                  <SubscriptionAdminPage />
                </RequireAuth>
              </Route>
              <Route exact path="/admin/students/:id">
                <RequireAuth test={(user) => user.isAdministrator}>
                  <StudentAdminPage />
                </RequireAuth>
              </Route>
              <Route exact path="/settings/fields">
                <FieldSettingsPage />
              </Route>
              <Route exact path="/settings">
                <SettingsPage />
              </Route>
              <Route exact path="/upgrade">
                <PricingPage />
              </Route>
              <Route exact path="/postUpgrade">
                <PostUpgradePage />
              </Route>
              <Route exact path="/parenthome">
                <RequireAuth test={(user) => user.isParent}>
                  <ParentPage />
                </RequireAuth>
              </Route>
              <Route exact path="/students">
                <RequireAuth test={(user) => user.isTeacher}>
                  <ClassPage />
                </RequireAuth>
              </Route>
              <Route exact path="/assistanthome">
                <RequireAuth test={(user) => user.isAssistant}>
                  <AssistantPage />
                </RequireAuth>
              </Route>
              <Route exact path="/students/new">
                <NewStudentPage />
              </Route>
              <Route exact path="/students/:id/edit/questions">
                <StudentQuestionsPage />
              </Route>
              <Route exact path="/students/:id/edit">
                <RequireAuth test={(user) => user.canEditStudents}>
                  <StudentEditPage />
                </RequireAuth>
              </Route>
              <Route exact path="/students/:id">
                <StudentPage />
              </Route>
              <Route exact path="/students/:id/reports">
                <RequireAuth test={(user) => user.isTeacher && user.isPro()}>
                  <ReportsViewPage />
                </RequireAuth>
              </Route>
              <Route exact path="/students/:studentId/reports/new">
                <NewReportPage />
              </Route>
              <Route exact path="/students/:studentId/reports/:reportId/edit">
                <RequireAuth
                  test={(user) => user.isTeacher || user.isAssistant}
                >
                  <AccessModalWrapper component={ReportEditPage} />
                </RequireAuth>
              </Route>
              <Route exact path="/students/:studentId/reports/:reportId">
                <AccessModalWrapper component={ReportViewPage} />
              </Route>
            </Switch>
          </ErrorBoundary>
        </div>
      </Container>
    </Router>
  );
};

export default App;
